import React, { ReactNode, useEffect, useState } from "react";
import CloseIcon from "./icons/CloseIcon";
import "./resources/scss/drawer.scss";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  styles?: {
    [key: string]: string;
  };
}

const DrawerApp: React.FC<DrawerProps> = ({
  isOpen,
  onClose,
  children,
  styles,
}) => {
  const [showCloseButton, setShowCloseButton] = useState<boolean>(false);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        setShowCloseButton(true);
      }, 180);
    } else {
      setShowCloseButton(false);
    }
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div className="drawer_app_drawer_overlay" onClick={onClose} />
      )}
      <div
        className={`drawer_app_drawer ${isOpen ? "open" : ""}`}
        style={{ ...styles }}
      >
        {children}

        {showCloseButton && (
        <button className="drawer_app_drawer_close_btn" onClick={onClose}>
          <div className="drawer_app_drawer_close_icon">
            <CloseIcon />
          </div>
        </button>
      )}
      </div>
    </>
  );
};

export default DrawerApp;
